/**
 * Created by Omar Alejandro Leonor Avalos on 2017-08-18.
 * PreInvoice Service
 */
import request from './request';
import { serializeParams } from '../common/helpers';
import { apiUrl } from '../app.config';
import { getToken } from '../security';

export const get = (url = '', params = {}) => {
    return request().get(`${url}${serializeParams(params)}`)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            //TODO Hay que hacer un buen manejo de errores. Por ahora simplemente regresamos test data pero se debe borrar y en caso de error en el webservice propagarlo a la vista de alguna forma para que se maneje posteriormente.
            return error;
            //return error;
        });
};

export const post = (url = '', params = {}) => {
    return request().post(url, params)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            return error;
        });
};

export const downloadFile = (params) => {
    const access_token = getToken();

    //window.open(`${apiUrl}/preInvoices/pdf${serializeParams({ ...params, access_token })}`, '_newTab');
    return request()
        .get(`preInvoices/pdf${serializeParams({ ...params })}`)
        .then(response => {
            //return response.data;
            var byteString = atob(response.data);
            // Convert that text into a byte array.
            var ab = new ArrayBuffer(byteString.length);
            var ia = new Uint8Array(ab);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            };

            // Blob for saving.
            var blob = new Blob([ia], { type: "octet/stream" });
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement("a");
            document.body.appendChild(a);
             a.href = url;
             a.download = params.customsClearenceFolio+"_"+params.preInvoiceSequence+".pdf";
             a.click();
             window.URL.revokeObjectURL(url);
             return response.data;
        })
        .catch((error) => alert("Hubo un problema al querer descargar este archivo"));
};

export const downloadAttachedFile = (params) => {

    return request()
        .get(`preInvoices/file${serializeParams({ ...params })}`)
        .then(response => {
            //return response.data;
            var byteString = atob(response.data);
            // Convert that text into a byte array.
            var ab = new ArrayBuffer(byteString.length);
            var ia = new Uint8Array(ab);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            };

            // Blob for saving.
            var blob = new Blob([ia], { type: "octet/stream" });
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement("a");
            document.body.appendChild(a);
             a.href = url;
             a.download = params.fileName;
             a.click();
             window.URL.revokeObjectURL(url);
             return response.data;
        })
        .catch((error) => alert("Hubo un problema al querer descargar este archivo"));
};

export const save = (preInvoiceData) => {
    const url = 'preInvoices';

    return request().post(url, preInvoiceData)
        .then(response => response.data)
        .catch((error) => error);
};


export const getAttachedFiles = (params = {}) => {
    return request()

        .get(`preInvoices/attachmentsList?customsClearenceFolio=${params.folio}`)
        .then(response => response)
        .catch((error) => error);
};



// WEBPACK FOOTER //
// ./services/preInvoice.js